import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import axios from 'axios';
import Grid from './Grid';
import swal from 'sweetalert';
import Tableselect from './Tabletselect';


// const https = require('https');
// import moment from 'moment';

let context;
class Centerpanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            loading: false,
        }
        context = this;
        this.updateSync = this.updateSync.bind(this);
    }
    // closeModal = () => this.setState({ open: false })
    close = () => {
        // alert("closed")
        this.setState({ select: {}, loading: false })
    }
    // getdata(id, entrada) {
    //     console.log("mounting..")
    //     this.setState({ loadingmodal: true })
    //     fetch(this.props.api + '/view/model/pcuc/id/' + id, { cache: "no-cache" }).then(results => {
    //         return results.json();
    //     }).then(modal => {
    //         this.setState({
    //             modal,
    //             entrada,
    //             loadingmodal: false
    //         })
    //         localStorage.setItem('modal', JSON.stringify(modal));
    //         localStorage.setItem('entrada', JSON.stringify(entrada));

    //     });
    //     this.setState({ open: true })
    // }
    updateSync() {
        // this.setState({ loading: true }); //Activa animacion durante la actualizacion

        if (this.props.match.params.idgroup) {
            console.log("Actualizando group");
            fetch(this.props.api + '/view/model/pcci/id/' + this.props.match.params.idgroup, { cache: "no-cache" }).then(results => {
                return results.json();
            }).then(select => {
                this.setState({
                    select,
                    idgroup: this.props.match.params.idgroup,
                    // loading: false
                })
                // localStorage.setItem('select', JSON.stringify(select));
            }).catch(function (error) {
                // if (localStorage.getItem('select') != null)
                // this.setState({ select: JSON.parse(localStorage.getItem('select')) })
            });
        } else if (this.props.match.params.idleague) {
            console.log("Actualizando league");
            fetch(this.props.api + '/view/model/pccs/id/' + this.props.match.params.idleague, { cache: "no-cache" }).then(results => {
                return results.json();
            }).then(select => {
                this.setState({
                    select,
                    idleague: this.props.match.params.idleague,
                    // loading: false
                })
                // localStorage.setItem('select', JSON.stringify(select));
                // console.table(data)
            }).catch(error => {
                // if (localStorage.getItem('select') != null)
                // this.setState({ select: JSON.parse(localStorage.getItem('select')) })
            });
        }
        // console.log("Actualizando Next");
        axios.get(this.props.api + '/match'/*, { httpsAgent: agent }*/)
            .then(res => {
                this.setState({
                    data: res.data,
                    // loading: false 
                });
                // localStorage.setItem('data', JSON.stringify(res.data));
            }).catch(error => {
                // console.log('capturado menor')
                // if (localStorage.getItem('data') != null) {
                // this.setState({ data: JSON.parse(localStorage.getItem('data')) });
                // }
            });
        // this.setState({ loading: false });

    }
    ajax(option) { // $.ajax(...) without jquery.

        if (typeof (option.type) == "undefined") {
            option.type = "GET";
        }
        if (typeof (option.data) == "undefined") {
            option.data = null;
        } else {
            var data = "";
            for (var x in option.data) {
                if (data != "") {
                    data += "&";
                }
                data += encodeURIComponent(x) + "=" + encodeURIComponent(option.data[x]);
            };
            option.data = data;
        }
        if (typeof (option.statusCode) == "undefined") { // 4
            option.statusCode = {};
        }
        if (typeof (option.beforeSend) == "undefined") { // 1
            option.beforeSend = function () { };
        }
        if (typeof (option.success) == "undefined") { // 4 et sans erreur
            option.success = function () { };
        }
        if (typeof (option.error) == "undefined") { // 4 et avec erreur
            option.error = function () { };
        }
        if (typeof (option.complete) == "undefined") { // 4
            option.complete = function () { };
        }
        typeof (option.statusCode["404"]);

        var xhr = null;

        if (window.XMLHttpRequest || window.ActiveXObject) {
            if (window.ActiveXObject) {
                try { xhr = new window.ActiveXObject("Msxml2.XMLHTTP"); }
                catch (e) { xhr = new window.ActiveXObject("Microsoft.XMLHTTP"); }
            }
            else { xhr = new XMLHttpRequest(); }
        } else { alert("Votre navigateur ne supporte pas l'objet XMLHTTPRequest..."); return null; }

        xhr.onreadystatechange = function () {
            if (xhr.readyState == 1) {
                option.beforeSend();
            }
            if (xhr.readyState == 4) {
                option.complete(xhr, xhr.status);
                if (xhr.status == 200 || xhr.status == 0) {
                    option.success(xhr.responseText);
                } else {
                    option.error(xhr.status);
                    if (typeof (option.statusCode[xhr.status]) != "undefined") {
                        option.statusCode[xhr.status]();
                    }
                }
            }
        };

        if (option.type == "POST") {
            xhr.open(option.type, option.url, true);
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
            xhr.send(option.data);
        } else {
            xhr.open(option.type, option.url + option.data, true);
            xhr.send(null);
        }

    }
    componentDidMount() {
        this.updateSync();
        setInterval(this.updateSync, 30000);
        if (this.props.match.params.token) {
            // console.log("token:", this.props.match.params.token);
            localStorage.setItem('token', JSON.stringify(this.props.match.params.token));
            localStorage.removeItem('value');
            this.props.login({ token: this.props.match.params.token }, true, true);
            document.title = "External Core";
            // let params = { operation: "getCustomerInfo", customerID: "alejandro" };
            // let x = JSON.stringify(params);

            // let out = this.ajax({
            //     url: 'https:/griffon.bet/extcore/service.php',
            //     cache: false,
            //     type: "POST",
            //     data: params,
            //     contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
            //     success: function(data) {
            //        console.log(data);
            //       },

            // });
            // console.log(out);


        }
    }
    static getDerivedStateFromProps(props, current_state) {

        // !context.state.loading ? context.setState({ loading:true }) : "";
        if (current_state.idleague !== props.match.params.idleague) {

            // console.log(props.match.params.idleague, window.innerWidth);

            var x = document.getElementById("sidebarCollapse");
            // If "mystyle" exist, overwrite it with "mystyle2"
            if (x && props.match.params.idleague && window.innerWidth < 768) {
                window.scroll(0, 0);
                x.click();
                // context.setState({ })
            }
            else if (props.match.params.idleague) {
                window.scroll(0, 0);
            }
            // context.updateSync();
            // console.log("Se actualizo la prop ", props.match.params.idsport, props.match.params.idpais);
            if (props.match.params.idleague) {
                console.log("cambio de liga")
                fetch(props.api + '/view/model/pccs/id/' + props.match.params.idleague, { cache: "no-cache" })
                    .then(results => {
                        return results.json();
                    }).then(select => {
                        context.setState({
                            select,
                            idleague: props.match.params.idleague,
                            loading: false
                        })
                        // localStorage.setItem('select', JSON.stringify(select));
                        // console.table(data)
                    }).catch(function (error) {
                        console.log('Hubo un problema con la petición Fetch:' + error.message);
                        context.setState({ select: {}, idleague: props.match.params.idleague })
                    });
            }

        }
        if (current_state.idgroup !== props.match.params.idgroup) {

            // window.scroll(0, 0);
            // console.log("Se actualizo la prop ", props.match.params.idsport, props.match.params.idpais);

            // context.updateSync();
            if (props.match.params.idgroup) {
                console.log("cambio de group");
                fetch(props.api + '/view/model/pcci/id/' + props.match.params.idgroup, { cache: "no-cache" })
                    .then(results => {
                        return results.json();
                    }).then(select => {
                        context.setState({
                            select,
                            idgroup: props.match.params.idgroup,
                            loading: false
                        })
                        // localStorage.setItem('select', JSON.stringify(select));
                        // console.table(data)
                    }).catch(function (error) {
                        console.log('Hubo un problema con la petición Fetch:' + error.message);
                        context.setState({ select: {}, idgroup: props.match.params.idgroup })
                        // context.setState({ loading: false })
                    });
            }

        }

        // return {
        //     loading: false,
        //     idleague: props.match.params.idleague,
        //     idgroup: props.match.params.idgroup
        // };
        return null;

    }

    render() {
        // moment.locale('es');
        // console.log("Pintando centerpanel " + this.state.loading, this.props.loading)
        let dataLeagues = this.state.data;
        let leagues = Object.keys(dataLeagues);

        return <div className="centerPanel">
            <Tableselect
                items={this.props.items}
                close={this.close}
                language={this.props.language}
                format={this.props.format}
                getdata={this.getdata}
                addTocart={this.props.addTocart}
                tableheader={this.state.select ? this.props.language(this.state.select.sport).text + ' ' + this.state.select.countryName : null}
                raw={this.state.select ? this.state.select : []}
                loading={this.state.loading}
            />

            <div className=" card-header" role="alert">
                <h5>
                    <span><i className="fas fa-trophy"></i> {this.props.language().next}</span>
                </h5>
            </div>
            <div className="accordion" id="accordionExample" style={{ textAlign: 'center' }}>
                {leagues.length > 0 && !this.state.loading ?
                    <Grid
                        raw={{ leagues: this.state.data }}
                        items={this.props.items}
                        addTocart={this.props.addTocart}
                        format={this.props.format}
                        language={this.props.language} /> :
                    <div className="lds-facebook"><div></div><div></div><div></div></div>}
                {/* {leagues} */}

            </div>

        </div>
    }
}

export default Centerpanel;


// WEBPACK FOOTER //
// ./src/components/Centerpanel.js